/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Whiteboard_TitleInputs */

const en_of_landing_whiteboard_title = /** @type {(inputs: Of_Landing_Whiteboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sketch ideas together`)
};

const id_of_landing_whiteboard_title = /** @type {(inputs: Of_Landing_Whiteboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambarkan ide bersama`)
};

/**
* | output |
* | --- |
* | "Sketch ideas together" |
*
* @param {Of_Landing_Whiteboard_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_whiteboard_title = /** @type {((inputs?: Of_Landing_Whiteboard_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Whiteboard_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_whiteboard_title(inputs)
	return en_of_landing_whiteboard_title(inputs)
});